import React from 'react';
/*
 * Copyright 2024 The Ansible plugin Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Grid } from '@material-ui/core';
import { QuickAccessCard } from './QuickAccessCard';
import { Favourites } from './Favourites';

export const EntityOverviewContent = () => {
  return (
    <Grid
      container
      spacing={2}
      justifyContent="space-between"
      data-testid="overview-content"
    >
      <Grid item xs={9} data-testid="quick-access-card">
        <QuickAccessCard />
      </Grid>
      <Grid item xs={3} data-testid="starred-entities">
        <Favourites />
      </Grid>
    </Grid>
  );
};
